import { getLocale } from "../runtime";

const sv_reachedfreeshipping = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Du får nu fri frakt!`
};

const reachedfreeshipping = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_reachedfreeshipping(inputs)
	return "reachedFreeShipping";
};

export { reachedfreeshipping as "reachedFreeShipping" };